module.exports = __webpack_public_path__ + "assets/19497dd5c09532f592abd0dbd5ca71d4.svg";